// extracted by mini-css-extract-plugin
export default {"root":"TextInput_root__a9FSH","input":"TextInput_input__s9t0w"};